// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1MKvg","title":"BackImages_title__3MZ_s","images":"BackImages_images__1oMoi"};